let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("52lcO")).then(() => parcelRequire('2ub4R'));